import { Component, OnInit } from '@angular/core';

import { UserContextService } from '../../../../core/services/user-context.service';
import { NewsHttpService } from '../../services/news-http.service';
import { INewsletter } from '../../interfaces/newsletter.interface';
import { INewsletterListResponse } from '../../interfaces/newsletter-list-response';
import {INewsHttpService} from '../../services/news-http.interface';

@Component({
    selector: 'news',
    templateUrl: './news-list.page.html',
    styleUrls: ['./news-list.page.scss']
})
export class NewsListComponent implements OnInit {

    newsletters: INewsletter[] = [];
    offersOnly: boolean = false;

    constructor(
        private userContextService: UserContextService,
        private newsService: INewsHttpService
    ) { }

    async ngOnInit() {
        console.log('NewsListComponent init');

        const userId = this.userContextService.getUserId();
        const response: INewsletterListResponse = await this.newsService.getList(userId);
        this.newsletters = response.newsletters;
    }

    getNewsletters(): INewsletter[] {
        return this.newsletters.filter((newsletter: INewsletter) => {
            if (!this.offersOnly) {
                return true;
            }
            return newsletter.isOffer;
        });
    }

    showAll(): void {
        this.offersOnly = false;
    }

    showOffersOnly(): void {
        this.offersOnly = true;
    }

}
